import templateUrl from './callout.html';

export function CalloutDirective(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            type: '='
        },
        transclude: true,
        templateUrl,
        link: function(){

        }
    };
}
